import { trpc } from "../api/trpc";

export interface UseCategoriesParams {
  includeBookCount?: boolean;
}

/**
 * Hook for fetching categories from the categories router
 */
export const useCategories = (params: UseCategoriesParams = {}) => {
  const { includeBookCount = true } = params;

  return trpc.categories.list.useQuery(
    { includeBookCount },
    {
      staleTime: 15 * 60 * 1000, // 15 minutes - categories change less frequently
      cacheTime: 30 * 60 * 1000, // 30 minutes
    },
  );
};

/**
 * Hook for fetching a single category by ID
 */
export const useCategory = (id: string) => {
  return trpc.categories.getById.useQuery(
    { id },
    {
      enabled: !!id, // Only run query if ID is provided
      staleTime: 15 * 60 * 1000, // 15 minutes
      cacheTime: 30 * 60 * 1000, // 30 minutes
    },
  );
};
